import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../../../common/SharedComponents';
import { LoanPageType, LoanStatusType } from '../../../../../loans/common/LoanConstants';
import LoansLandingPageGeneric from '../../../../../loans/LoansLandingPageGeneric';
import { LoansWorkspacePage } from '../../../../../loans/LoansWorkspacePage/LoansWorkspacePage';

export default function LoansApprovedRoutes() {
    return (
        <>
            <Route
                path='/loans/approved/loc'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.LOC}
                            statusId={LoanStatusType.Approved}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/approved/construction'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Construction}
                            statusId={LoanStatusType.Approved}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/approved/rental'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Rental}
                            statusId={LoanStatusType.Approved}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/approved/buildrent'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.BuildRent}
                            statusId={LoanStatusType.Approved}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/approved/fixflip'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.FixFlip}
                            statusId={LoanStatusType.Approved}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/approved/land'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Land}
                            statusId={LoanStatusType.Approved}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/approved/model'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Model}
                            statusId={LoanStatusType.Approved}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/approved/bridge'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Bridge}
                            statusId={LoanStatusType.Approved}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/approved'
                element={
                    <RequireAdmin>
                        <LoansWorkspacePage status={LoanStatusType.Approved} />
                    </RequireAdmin>
                }
            />
        </>
    );
}
